// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import routerPromise from './router'
import ElementUI from 'element-ui';
// import '@/config/css/element/theme/index.css';
import 'element-ui/lib/theme-chalk/index.css';
import utils from './utils/utils';
import '@/config/css/style.less'
// 导入全局组件 并注册
import vueComs from './components/index';
vueComs()

Vue.use(ElementUI);
Vue.prototype.$utils = utils;


Vue.config.productionTip = false

/* eslint-disable no-new */
routerPromise.then(router => {
  console.log('router',router)
  new Vue({
    el: '#app',
    router: router.router,
    components: { App },
    template: '<App/>'
  })
})


// WEBPACK FOOTER //
// ./src/main.js